// 🌍 Regional Climate Data for Recommendation Engine
// Generated from recommendation-engine-data.txt

import { RegionalClimateData } from '@/lib/types/recommendation-engine'

export const REGIONAL_CLIMATE_DATA: Record<string, RegionalClimateData> = {
  'Northeast': {
    zone: 'Northeast - Cool Season',
    primaryGrasses: ['Kentucky Bluegrass', 'Perennial Ryegrass', 'Fine Fescue', 'Tall Fescue'],
    description: 'Cool-season grasses that thrive in northern climates with cold winters and moderate summers',
    avgTemperature: {
      spring: '45-65°F',
      summer: '65-80°F',
      fall: '45-65°F',
      winter: '20-40°F'
    },
    rainfallPattern: 'Moderate year-round, wet springs',
    lastFrost: 'April 15-May 1',
    firstFrost: 'October 1-15',
    commonChallenges: ['Snow mold', 'summer stress', 'crabgrass'],
    soilType: 'Variable (clay to sandy loam)',
    humidity: 'Medium-High',
    soilTemperature: {
      spring: {
        march: '35-45°F',
        april: '45-55°F',
        may: '50-65°F'
      },
      summer: {
        june: '55-70°F',
        july: '60-75°F',
        august: '55-70°F'
      },
      fall: {
        september: '50-65°F',
        october: '40-55°F',
        november: '30-45°F'
      },
      winter: {
        december: '25-35°F',
        january: '20-30°F',
        february: '25-40°F'
      }
    },
    criticalTiming: {
      preEmergentWindow: 'March 15 - April 15',
      postEmergentOptimal: ['Early spring (April-May)', 'Late fall (September-October)'],
      soilTempTargets: {
        preEmergent: 55,
        postEmergent: 60
      }
    }
  },
  
  'Mid-Atlantic': {
    zone: 'Mid-Atlantic - Transition Zone',
    primaryGrasses: ['Tall Fescue', 'Kentucky Bluegrass', 'Fine Fescue', 'Bermudagrass'],
    description: 'Transition zone where both cool and warm-season grasses can grow',
    avgTemperature: {
      spring: '50-70°F',
      summer: '70-85°F',
      fall: '50-70°F',
      winter: '30-50°F'
    },
    rainfallPattern: 'Moderate, summer droughts possible',
    lastFrost: 'March 15-April 15',
    firstFrost: 'October 15-November 1',
    commonChallenges: ['Summer stress', 'fungal diseases', 'grub damage'],
    soilType: 'Clay loam to sandy',
    humidity: 'Medium-High',
    soilTemperature: {
      spring: {
        march: '40-50°F',
        april: '50-60°F',
        may: '55-70°F'
      },
      summer: {
        june: '60-75°F',
        july: '65-80°F',
        august: '60-75°F'
      },
      fall: {
        september: '55-70°F',
        october: '45-60°F',
        november: '35-50°F'
      },
      winter: {
        december: '30-45°F',
        january: '25-40°F',
        february: '30-50°F'
      }
    },
    criticalTiming: {
      preEmergentWindow: 'March 15 - April 15',
      postEmergentOptimal: ['Early spring (March-April)', 'Late fall (October-November)'],
      soilTempTargets: {
        preEmergent: 55,
        postEmergent: 60
      }
    }
  },
  
  'Southeast': {
    zone: 'Southeast - Warm Season',
    primaryGrasses: ['Bermudagrass', 'Zoysiagrass', 'St. Augustinegrass', 'Centipede', 'Bahiagrass'],
    description: 'Warm-season grasses adapted to hot, humid summers',
    avgTemperature: {
      spring: '60-80°F',
      summer: '75-90°F',
      fall: '60-80°F',
      winter: '40-60°F'
    },
    rainfallPattern: 'Wet summers, dry winters',
    lastFrost: 'February 15-March 15',
    firstFrost: 'November 15-December 15',
    commonChallenges: ['Chinch bugs', 'brown patch', 'summer diseases'],
    soilType: 'Sandy to clay',
    humidity: 'High',
    soilTemperature: {
      spring: {
        march: '50-65°F',
        april: '60-75°F',
        may: '65-80°F'
      },
      summer: {
        june: '70-85°F',
        july: '75-90°F',
        august: '70-85°F'
      },
      fall: {
        september: '65-80°F',
        october: '55-70°F',
        november: '45-60°F'
      },
      winter: {
        december: '40-55°F',
        january: '35-50°F',
        february: '40-60°F'
      }
    },
    criticalTiming: {
      preEmergentWindow: 'February 15 - March 15',
      postEmergentOptimal: ['Early spring (February-March)', 'Fall (October-November)'],
      soilTempTargets: {
        preEmergent: 55,
        postEmergent: 65
      }
    }
  },
  
  'Great Lakes': {
    zone: 'Great Lakes - Cool Season',
    primaryGrasses: ['Kentucky Bluegrass', 'Perennial Ryegrass', 'Tall Fescue', 'Fine Fescue'],
    description: 'Cool-season region with harsh winters and moderate summers',
    avgTemperature: {
      spring: '40-60°F',
      summer: '60-75°F',
      fall: '40-60°F',
      winter: '10-30°F'
    },
    rainfallPattern: 'Moderate, snow in winter',
    lastFrost: 'April 15-May 15',
    firstFrost: 'September 15-October 15',
    commonChallenges: ['Winter kill', 'short growing season', 'snow mold'],
    soilType: 'Clay to loam',
    humidity: 'Medium',
    soilTemperature: {
      spring: {
        march: '35-45°F',
        april: '45-55°F',
        may: '55-65°F'
      },
      summer: {
        june: '60-70°F',
        july: '70-80°F',
        august: '65-75°F'
      },
      fall: {
        september: '60-70°F',
        october: '50-60°F',
        november: '35-45°F'
      },
      winter: {
        december: '30-40°F',
        january: '25-35°F',
        february: '30-40°F'
      }
    },
    criticalTiming: {
      preEmergentWindow: 'April 1 - May 1',
      postEmergentOptimal: ['Late spring (May-June)', 'Early fall (September-October)'],
      soilTempTargets: {
        preEmergent: 55,
        postEmergent: 60
      }
    }
  },

  'Upper Midwest': {
    zone: 'Upper Midwest - Cool Season',
    primaryGrasses: ['Kentucky Bluegrass', 'Fine Fescue', 'Tall Fescue', 'Perennial Ryegrass'],
    description: 'Cool-season grasses adapted to very cold winters',
    avgTemperature: {
      spring: '35-55°F',
      summer: '55-75°F',
      fall: '35-55°F',
      winter: '0-25°F'
    },
    rainfallPattern: 'Moderate, heavy snow',
    lastFrost: 'May 1-15',
    firstFrost: 'September 1-15',
    commonChallenges: ['Extremely short season', 'winter damage', 'snow mold'],
    soilType: 'Rich prairie soils',
    humidity: 'Medium',
    soilTemperature: {
      spring: {
        march: '30-40°F',
        april: '40-50°F',
        may: '50-60°F'
      },
      summer: {
        june: '60-70°F',
        july: '70-80°F',
        august: '65-75°F'
      },
      fall: {
        september: '55-65°F',
        october: '45-55°F',
        november: '30-40°F'
      },
      winter: {
        december: '25-35°F',
        january: '15-25°F',
        february: '20-30°F'
      }
    },
    criticalTiming: {
      preEmergentWindow: 'April 15 - May 15',
      postEmergentOptimal: ['Late spring (May-June)', 'Early fall (September)'],
      soilTempTargets: {
        preEmergent: 55,
        postEmergent: 60
      }
    }
  },

  'Central': {
    zone: 'Central - Transition Zone',
    primaryGrasses: ['Tall Fescue', 'Kentucky Bluegrass', 'Bermudagrass', 'Zoysiagrass'],
    description: 'Transition zone with mixed grass types depending on microclimate',
    avgTemperature: {
      spring: '45-70°F',
      summer: '70-90°F',
      fall: '45-70°F',
      winter: '20-45°F'
    },
    rainfallPattern: 'Variable, drought periods common',
    lastFrost: 'March 15-April 15',
    firstFrost: 'October 15-November 1',
    commonChallenges: ['Extreme weather swings', 'drought', 'heat stress'],
    soilType: 'Prairie soils to clay',
    humidity: 'Medium',
    soilTemperature: {
      spring: {
        march: '40-50°F',
        april: '50-60°F',
        may: '60-70°F'
      },
      summer: {
        june: '70-80°F',
        july: '75-85°F',
        august: '70-80°F'
      },
      fall: {
        september: '65-75°F',
        october: '50-60°F',
        november: '35-45°F'
      },
      winter: {
        december: '30-40°F',
        january: '25-35°F',
        february: '30-40°F'
      }
    },
    criticalTiming: {
      preEmergentWindow: 'March 15 - April 15',
      postEmergentOptimal: ['Late spring (May-June)', 'Early fall (September-October)'],
      soilTempTargets: {
        preEmergent: 55,
        postEmergent: 60
      }
    }
  },

  'South Central': {
    zone: 'South Central - Warm Season',
    primaryGrasses: ['Bermudagrass', 'St. Augustinegrass', 'Zoysiagrass', 'Buffalograss', 'Bahiagrass'],
    description: 'Warm-season grasses adapted to hot, dry conditions',
    avgTemperature: {
      spring: '65-85°F',
      summer: '80-100°F',
      fall: '65-85°F',
      winter: '45-65°F'
    },
    rainfallPattern: 'Variable, frequent droughts',
    lastFrost: 'February 1-March 1',
    firstFrost: 'November 15-December 15',
    commonChallenges: ['Extreme heat', 'drought', 'fire ants'],
    soilType: 'Clay to sandy',
    humidity: 'Medium-Low',
    soilTemperature: {
      spring: {
        march: '55-65°F',
        april: '60-70°F',
        may: '70-80°F'
      },
      summer: {
        june: '80-90°F',
        july: '85-95°F',
        august: '85-90°F'
      },
      fall: {
        september: '75-85°F',
        october: '60-70°F',
        november: '50-60°F'
      },
      winter: {
        december: '45-55°F',
        january: '40-50°F',
        february: '45-55°F'
      }
    },
    criticalTiming: {
      preEmergentWindow: 'February 1 - March 1',
      postEmergentOptimal: ['Early spring (March-April)', 'Fall (October-November)'],
      soilTempTargets: {
        preEmergent: 55,
        postEmergent: 65
      }
    }
  },

  'Mountain West': {
    zone: 'Mountain West - Cool Season',
    primaryGrasses: ['Kentucky Bluegrass', 'Fine Fescue', 'Tall Fescue', 'Buffalograss'],
    description: 'Cool-season grasses adapted to high altitude and dry conditions',
    avgTemperature: {
      spring: '35-60°F',
      summer: '60-80°F',
      fall: '35-60°F',
      winter: '10-35°F'
    },
    rainfallPattern: 'Low precipitation, snow in winter',
    lastFrost: 'May 15-June 1',
    firstFrost: 'September 1-15',
    commonChallenges: ['High altitude', 'low humidity', 'short season'],
    soilType: 'Rocky, alkaline soils',
    humidity: 'Low',
    soilTemperature: {
      spring: {
        march: '35-45°F',
        april: '45-55°F',
        may: '55-65°F'
      },
      summer: {
        june: '65-75°F',
        july: '70-80°F',
        august: '65-75°F'
      },
      fall: {
        september: '55-65°F',
        october: '45-55°F',
        november: '30-40°F'
      },
      winter: {
        december: '25-35°F',
        january: '20-30°F',
        february: '25-35°F'
      }
    },
    criticalTiming: {
      preEmergentWindow: 'April 15 - May 15',
      postEmergentOptimal: ['Late spring (June)', 'Early fall (September)'],
      soilTempTargets: {
        preEmergent: 55,
        postEmergent: 60
      }
    }
  },

  'West Coast': {
    zone: 'West Coast - Mixed',
    primaryGrasses: ['Tall Fescue', 'Kentucky Bluegrass', 'Fine Fescue', 'Bermudagrass'],
    description: 'Mixed climate zones with both cool and warm-season grasses',
    avgTemperature: {
      spring: '55-70°F',
      summer: '65-80°F',
      fall: '55-70°F',
      winter: '45-60°F'
    },
    rainfallPattern: 'Wet winters, dry summers',
    lastFrost: 'January 15-March 15',
    firstFrost: 'November 15-December 31',
    commonChallenges: ['Summer drought', 'water restrictions', 'salt air'],
    soilType: 'Variable (sandy to clay)',
    humidity: 'Medium (coastal) to Low (inland)',
    soilTemperature: {
      spring: {
        march: '45-55°F',
        april: '50-60°F',
        may: '55-65°F'
      },
      summer: {
        june: '60-70°F',
        july: '65-75°F',
        august: '60-70°F'
      },
      fall: {
        september: '55-65°F',
        october: '50-60°F',
        november: '40-50°F'
      },
      winter: {
        december: '40-45°F',
        january: '38-45°F',
        february: '40-48°F'
      }
    },
    criticalTiming: {
      preEmergentWindow: 'March 1 - April 15',
      postEmergentOptimal: ['Spring (April-May)', 'Early fall (September-October)'],
      soilTempTargets: {
        preEmergent: 55,
        postEmergent: 60
      }
    }
  },

  Hawaii: {
    zone: 'Hawaii - Warm Season',
    primaryGrasses: ['Bermudagrass', 'Zoysiagrass', 'St. Augustinegrass', 'Centipede'],
    description: 'Warm-season grasses adapted to tropical humidity and year-round growth',
    avgTemperature: {
      spring: '70-82°F',
      summer: '78-88°F',
      fall: '72-84°F',
      winter: '65-78°F',
    },
    rainfallPattern: 'Wet winters, drier summers on leeward sides',
    lastFrost: 'Rare',
    firstFrost: 'Rare',
    commonChallenges: ['Heavy rain', 'salty air', 'disease pressure'],
    soilType: 'Volcanic to sandy',
    humidity: 'High',
    soilTemperature: {
      spring: { march: '68-74°F', april: '70-76°F', may: '72-78°F' },
      summer: { june: '74-80°F', july: '76-82°F', august: '76-82°F' },
      fall: { september: '74-80°F', october: '72-78°F', november: '70-76°F' },
      winter: { december: '68-74°F', january: '66-72°F', february: '67-73°F' },
    },
    criticalTiming: {
      preEmergentWindow: 'February 1 - March 15',
      postEmergentOptimal: ['Early spring', 'Fall'],
      soilTempTargets: { preEmergent: 55, postEmergent: 65 },
    },
  },

  Alaska: {
    zone: 'Alaska - Cool Season',
    primaryGrasses: ['Kentucky Bluegrass', 'Fine Fescue', 'Perennial Ryegrass'],
    description: 'Cool-season grasses for short summers and cold winters',
    avgTemperature: {
      spring: '35-50°F',
      summer: '55-70°F',
      fall: '35-50°F',
      winter: '0-20°F',
    },
    rainfallPattern: 'Variable by region, long snow season',
    lastFrost: 'May 15-June 15',
    firstFrost: 'August 15-September 15',
    commonChallenges: ['Short season', 'permafrost near surface', 'low light'],
    soilType: 'Organic to rocky',
    humidity: 'Medium',
    soilTemperature: {
      spring: { march: '28-38°F', april: '35-45°F', may: '42-52°F' },
      summer: { june: '50-60°F', july: '55-65°F', august: '52-62°F' },
      fall: { september: '45-55°F', october: '35-45°F', november: '25-35°F' },
      winter: { december: '20-30°F', january: '15-25°F', february: '18-28°F' },
    },
    criticalTiming: {
      preEmergentWindow: 'May 15 - June 15',
      postEmergentOptimal: ['Late spring', 'Early fall'],
      soilTempTargets: { preEmergent: 50, postEmergent: 55 },
    },
  },

  'Pacific Northwest': {
    zone: 'Pacific Northwest - Cool Season Marine',
    primaryGrasses: ['Perennial Ryegrass', 'Tall Fescue', 'Fine Fescue', 'Kentucky Bluegrass'],
    description: 'Cool-season grasses thriving in the mild, wet marine climate west of the Cascades, with a long green season and cool, dry summers',
    avgTemperature: {
      spring: '45-62°F',
      summer: '60-78°F',
      fall: '45-62°F',
      winter: '35-48°F'
    },
    rainfallPattern: 'Wet October-May, dry summers (summer irrigation usually needed)',
    lastFrost: 'March 15-April 15',
    firstFrost: 'November 1-15',
    commonChallenges: ['Moss in shade and wet soil', 'red thread', 'fusarium patch'],
    soilType: 'Acidic loam (often needs lime)',
    humidity: 'High (winter), Low-Medium (summer)',
    soilTemperature: {
      spring: { march: '42-48°F', april: '48-54°F', may: '52-60°F' },
      summer: { june: '58-66°F', july: '62-70°F', august: '62-70°F' },
      fall: { september: '58-64°F', october: '50-58°F', november: '42-50°F' },
      winter: { december: '40-46°F', january: '38-44°F', february: '40-46°F' }
    },
    criticalTiming: {
      preEmergentWindow: 'February 15 - March 31',
      postEmergentOptimal: ['Spring (March-May)', 'Early fall (September-October)'],
      soilTempTargets: { preEmergent: 55, postEmergent: 60 }
    }
  },

  'California': {
    zone: 'California - Mediterranean (Mixed Season)',
    primaryGrasses: ['Tall Fescue', 'Bermudagrass', 'St. Augustinegrass', 'Kentucky Bluegrass'],
    description: 'Mediterranean climate with mild, wet winters and dry summers; cool-season fescues along the coast and inland valleys, warm-season bermuda and St. Augustine in hotter zones',
    avgTemperature: {
      spring: '55-72°F',
      summer: '68-88°F',
      fall: '58-78°F',
      winter: '42-62°F'
    },
    rainfallPattern: 'Wet November-March, dry summers (irrigation-dependent)',
    lastFrost: 'January 15-March 1 (many coastal areas frost-free)',
    firstFrost: 'November 15-December 15',
    commonChallenges: ['Drought and water restrictions', 'summer heat stress on cool-season lawns', 'billbugs'],
    soilType: 'Variable, often alkaline (clay to sandy)',
    humidity: 'Low-Medium',
    soilTemperature: {
      spring: { march: '52-60°F', april: '56-66°F', may: '60-72°F' },
      summer: { june: '66-78°F', july: '70-82°F', august: '70-82°F' },
      fall: { september: '66-76°F', october: '58-68°F', november: '50-60°F' },
      winter: { december: '46-54°F', january: '44-52°F', february: '48-58°F' }
    },
    criticalTiming: {
      preEmergentWindow: 'January 15 - February 28',
      postEmergentOptimal: ['Spring (February-April)', 'Fall (October-November)'],
      soilTempTargets: { preEmergent: 52, postEmergent: 60 }
    }
  },

  'Desert Southwest': {
    zone: 'Desert Southwest - Warm Arid',
    primaryGrasses: ['Bermudagrass', 'St. Augustinegrass', 'Zoysiagrass', 'Buffalograss'],
    description: 'Hot, arid low desert where warm-season bermuda dominates, with winter perennial-rye overseed for year-round green; low humidity, intense summer heat, and mild winters',
    avgTemperature: {
      spring: '65-88°F',
      summer: '90-105°F',
      fall: '70-92°F',
      winter: '45-68°F'
    },
    rainfallPattern: 'Very low; summer monsoon (July-August) plus sparse winter rain (irrigation essential)',
    lastFrost: 'January 15-February 15',
    firstFrost: 'December 1-15',
    commonChallenges: ['Extreme heat and drought', 'alkaline and saline soils', 'winter dormancy of bermuda (overseed)'],
    soilType: 'Alkaline, sandy or caliche, low organic matter',
    humidity: 'Low',
    soilTemperature: {
      spring: { march: '58-68°F', april: '66-78°F', may: '74-86°F' },
      summer: { june: '82-92°F', july: '86-96°F', august: '85-95°F' },
      fall: { september: '80-90°F', october: '68-80°F', november: '56-68°F' },
      winter: { december: '50-60°F', january: '48-58°F', february: '52-64°F' }
    },
    criticalTiming: {
      preEmergentWindow: 'February 1 - February 28',
      postEmergentOptimal: ['Late spring (April-May)', 'Early fall (September)'],
      soilTempTargets: { preEmergent: 60, postEmergent: 65 }
    }
  },

  'Florida': {
    zone: 'Florida - Subtropical Warm Season',
    primaryGrasses: ['St. Augustinegrass', 'Bahiagrass', 'Zoysiagrass', 'Bermudagrass', 'Centipede'],
    description: 'Subtropical climate with near year-round growth; St. Augustine dominates home lawns, alongside Bahia, Zoysia, and Bermuda, under hot humid summers and mild winters',
    avgTemperature: {
      spring: '68-85°F',
      summer: '80-92°F',
      fall: '70-86°F',
      winter: '50-75°F'
    },
    rainfallPattern: 'High; wet summers (daily thunderstorms June-September), drier winters',
    lastFrost: 'North FL January 15-February 15 (Central/South FL largely frost-free)',
    firstFrost: 'December 1-31 (North FL only)',
    commonChallenges: ['Chinch bugs (St. Augustine)', 'gray leaf spot', 'nematodes', 'year-round weed pressure'],
    soilType: 'Sandy, fast-draining, low CEC',
    humidity: 'High',
    soilTemperature: {
      spring: { march: '66-74°F', april: '72-80°F', may: '78-86°F' },
      summer: { june: '82-88°F', july: '84-90°F', august: '84-90°F' },
      fall: { september: '82-88°F', october: '74-82°F', november: '66-74°F' },
      winter: { december: '60-68°F', january: '58-66°F', february: '62-70°F' }
    },
    criticalTiming: {
      preEmergentWindow: 'February 1 - February 28',
      postEmergentOptimal: ['Spring (March-April)', 'Fall (October)'],
      soilTempTargets: { preEmergent: 65, postEmergent: 70 }
    }
  }
}

// ZIP code to region mapping
export const ZIP_TO_REGION_MAP: Record<string, string> = {
  '0': 'Northeast',      // 00000-09999 (CT, MA, ME, NH, NJ, PR, RI, VT, VI)
  '1': 'Northeast',      // 10000-19999
  '2': 'Mid-Atlantic',   // 20000-29999
  '3': 'Southeast',      // 30000-39999
  '4': 'Great Lakes',    // 40000-49999
  '5': 'Upper Midwest',  // 50000-59999
  '6': 'Central',        // 60000-69999
  '7': 'South Central',  // 70000-79999
  '8': 'Mountain West',  // 80000-89999
  '9': 'West Coast'      // 90000-99999
}

// Default grass type per region — used when user selects "Not Sure"
export const REGION_DEFAULT_GRASS: Record<string, string> = {
  'Northeast': 'Kentucky Bluegrass',
  'Mid-Atlantic': 'Tall Fescue',
  'Southeast': 'Bermudagrass',
  'Great Lakes': 'Kentucky Bluegrass',
  'Upper Midwest': 'Kentucky Bluegrass',
  'Central': 'Tall Fescue',
  'South Central': 'Bermudagrass',
  'Mountain West': 'Kentucky Bluegrass',
  'West Coast': 'Tall Fescue',
  'Pacific Northwest': 'Perennial Ryegrass',
  'California': 'Tall Fescue',
  'Desert Southwest': 'Bermudagrass',
  'Florida': 'St. Augustinegrass',
  'Hawaii': 'Bermudagrass',
  'Alaska': 'Kentucky Bluegrass'
}

/** Maps the fine-grained climate sub-regions (added 2026-06-20) down to their
 * closest LEGACY region for downstream data systems (cost, plan calendars,
 * seeding, herbicide, compatibility, season) that are keyed on the original
 * region set. The new regions keep their identity for climate data, RAG
 * candidate ranking, the picker, and the result label. */
export const REGION_LEGACY_PARENT: Record<string, string> = {
  'California': 'West Coast',
  'Pacific Northwest': 'West Coast',
  'Desert Southwest': 'South Central',
  'Florida': 'Southeast',
}

export function toLegacyRegion(region: string): string {
  return REGION_LEGACY_PARENT[region] ?? region
}

// Helper function to get region from ZIP code.
// Uses a 3-digit prefix to special-case HI/AK/PR before the coarse first-digit
// fallback, mirroring mobile/data/regional-climate.ts so web and mobile resolve
// the same region for the same ZIP (web previously mapped HI/AK to "West Coast").
export function getRegionFromZipCode(zipCode: string): string {
  if (!zipCode || zipCode.length < 5) return 'Unknown'

  // Lowest valid US ZIP is 00501 (Holtsville, NY)
  const numeric = parseInt(zipCode, 10)
  if (isNaN(numeric) || numeric < 501) return 'Unknown'

  const prefix = zipCode.slice(0, 3)
  const prefixNum = parseInt(prefix, 10)

  // Puerto Rico / US Virgin Islands (006–009), treated as warm Southeast for v1
  if (prefix.startsWith('00') && prefixNum >= 6 && prefixNum <= 9) {
    return 'Southeast'
  }

  // Hawaii: 967–969 (NOT all 96xxx — 960–961 are California)
  if (prefix === '967' || prefix === '968' || prefix === '969') {
    return 'Hawaii'
  }

  // Alaska: 995–999
  if (prefixNum >= 995 && prefixNum <= 999) {
    return 'Alaska'
  }

  // Climate sub-regions that split the coarse first-digit buckets, fixing the
  // worst mismatches: "9" lumped warm-season SoCal with cool-season Pacific NW,
  // "8" lumped the hot AZ/NV desert with the cool high-altitude Mountain West,
  // and "3" lumped subtropical Florida with the broader Southeast. Ranges are
  // disjoint. Keep in sync with the DB (kb_zip3_region_map / get_region_by_zip)
  // and mobile/data/regional-climate.ts.
  if (prefixNum >= 320 && prefixNum <= 349) return 'Florida'
  if ((prefixNum >= 850 && prefixNum <= 865) || (prefixNum >= 889 && prefixNum <= 891)) return 'Desert Southwest'
  if (prefixNum >= 900 && prefixNum <= 961) return 'California'
  if (prefixNum >= 970 && prefixNum <= 994) return 'Pacific Northwest'

  const firstDigit = zipCode.charAt(0)
  const regionName = ZIP_TO_REGION_MAP[firstDigit]

  return regionName || 'Unknown'
}

// Helper function to get regional climate data
export function getRegionalClimateData(zipCode: string): RegionalClimateData | null {
  const regionName = getRegionFromZipCode(zipCode)
  return REGIONAL_CLIMATE_DATA[regionName] || null
}

// Helper function to get all regions
export function getAllRegions(): string[] {
  return Object.keys(REGIONAL_CLIMATE_DATA)
}

// Helper function to get regions by grass type suitability
export function getRegionsForGrassType(grassType: string): string[] {
  return Object.entries(REGIONAL_CLIMATE_DATA)
    .filter(([_, data]) => data.primaryGrasses.includes(grassType))
    .map(([regionName, _]) => regionName)
}

// Helper function to check if region is transition zone
export function isTransitionZone(regionName: string): boolean {
  const region = REGIONAL_CLIMATE_DATA[regionName]
  return region?.zone.includes('Transition') || false
}

export function getRegionInsight(regionName: string): string | null {
  if (!regionName || regionName === "Unknown") {
    return null
  }
  if (isTransitionZone(regionName)) {
    return "Both cool- and warm-season grasses are common here. We highlighted the most likely options first."
  }
  const zone = REGIONAL_CLIMATE_DATA[regionName]?.zone || ""
  if (zone.includes("Warm Season")) {
    return "Warm-season grasses are most common here. Start with the recommended options below."
  }
  if (zone.includes("Cool Season")) {
    return "Cool-season grasses are most common here. Start with the recommended options below."
  }
  return "These are the most common lawn grasses for your area."
}
